export default "__VITE_ASSET__Cdugc06___"